import SessionManager from "./SessionManager";
import { BASE_URL } from "store/services/URL";
import { getJourneyHeaders } from "./journeyHeaders";

const MAX_BUFFER_SIZE = 200;
const FLUSH_INTERVAL_MS = 30000;

let buffer = [];
let flushTimer = null;
let currentFlushInterval = FLUSH_INTERVAL_MS;

function getAuthHeaders() {
  const token = localStorage.getItem("accessToken");
  const headers = {
    "Content-Type": "application/json",
    accept: "application/json",
    ...getJourneyHeaders(),
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const cachedProvider = localStorage.getItem("selectedProvider");
  if (cachedProvider) {
    try {
      const parsed = JSON.parse(cachedProvider);
      if (parsed?.value) headers["sp_id"] = parsed.value;
    } catch (e) {
      // ignore
    }
  }
  return headers;
}

async function flushBuffer() {
  if (buffer.length === 0) return;

  const sessionId = SessionManager.getSessionId();
  if (!sessionId) return;

  const eventsToSend = [...buffer];
  buffer = [];

  try {
    const response = await fetch(`${BASE_URL}sp/journey/events`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        session_id: sessionId,
        events: eventsToSend,
      }),
    });

    if (response.status === 429 || response.status === 503) {
      buffer = [...eventsToSend, ...buffer].slice(0, MAX_BUFFER_SIZE);
      currentFlushInterval = Math.min(currentFlushInterval * 2, 120000);
      restartTimer();
      return;
    }

    if (currentFlushInterval !== FLUSH_INTERVAL_MS) {
      currentFlushInterval = FLUSH_INTERVAL_MS;
      restartTimer();
    }
  } catch {
    buffer = [...eventsToSend, ...buffer].slice(0, MAX_BUFFER_SIZE);
  }
}

function flushViaBeacon() {
  if (buffer.length === 0) return;

  const sessionId = SessionManager.getSessionId();
  if (!sessionId) return;

  const token = localStorage.getItem("accessToken");
  const payload = JSON.stringify({
    session_id: sessionId,
    token: token,
    events: buffer,
  });

  try {
    const blob = new Blob([payload], { type: "application/json" });
    navigator.sendBeacon(`${BASE_URL}sp/journey/events`, blob);
  } catch {
    // Best effort — accept the loss
  }

  buffer = [];
}

function restartTimer() {
  if (flushTimer) clearInterval(flushTimer);
  flushTimer = setInterval(flushBuffer, currentFlushInterval);
}

const JourneyEventBuffer = {
  track(eventType, data = {}) {
    if (!SessionManager.isActive()) return;

    const event = {
      event_type: eventType,
      route: window.location.pathname,
      client_timestamp: new Date().toISOString(),
      ...data,
    };

    buffer.push(event);

    if (buffer.length > MAX_BUFFER_SIZE) {
      buffer = buffer.slice(-MAX_BUFFER_SIZE);
    }

    if (buffer.length >= 50) {
      flushBuffer();
    }
  },

  start() {
    if (flushTimer) return;
    currentFlushInterval = FLUSH_INTERVAL_MS;
    flushTimer = setInterval(flushBuffer, currentFlushInterval);

    window.addEventListener("beforeunload", flushViaBeacon);
    window.addEventListener("pagehide", flushViaBeacon);
  },

  stop() {
    if (flushTimer) {
      clearInterval(flushTimer);
      flushTimer = null;
    }
    flushBuffer();
    window.removeEventListener("beforeunload", flushViaBeacon);
    window.removeEventListener("pagehide", flushViaBeacon);
  },

  flush() {
    return flushBuffer();
  },

  getBufferSize() {
    return buffer.length;
  },
};

export default JourneyEventBuffer;
